/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UploadAuthSupportsRequestFile$Params {

/**
 * The object ID. Must be a valid ID.
 */
  subscriptionUid: string;
      body?: Blob
}

export function uploadAuthSupportsRequestFile(http: HttpClient, rootUrl: string, params: UploadAuthSupportsRequestFile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, uploadAuthSupportsRequestFile.PATH, 'post');
  if (params) {
    rb.path('subscriptionUid', params.subscriptionUid, {});
    rb.body(params.body, 'application/vnd.ms-excel');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

uploadAuthSupportsRequestFile.PATH = '/custom/auth-supports-requests/import/{subscriptionUid}';
